import api from './api';
import { User, UserRegisterDto, UserUpdateDto } from '../types/types';

export const userService = {
    // Get all users
    getAllUsers: async (): Promise<User[]> => {
        const response = await api.get<User[]>('/users');
        return response.data;
    },

    // Get user by ID
    getUserById: async (id: number): Promise<User> => {
        const response = await api.get<User>(`/users/${id}`);
        return response.data;
    },

    // Create new user (register)
    createUser: async (userData: UserRegisterDto): Promise<User> => {
        const response = await api.post<User>('/users', userData);
        return response.data;
    },

    // Update user
    updateUser: async (id: number, userData: UserUpdateDto): Promise<void> => {
        await api.put(`/users/${id}`, userData);
    },

    // Delete user
    deleteUser: async (id: number): Promise<void> => {
        await api.delete(`/users/${id}`);
    },
};
